import { render, staticRenderFns } from "./PDPStickyCTAButton.vue?vue&type=template&id=44f89ef7"
var script = {}
import style0 from "./PDPStickyCTAButton.vue?vue&type=style&index=0&id=44f89ef7&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports